import {
  TokenAnalytics,
  SSEResponse,
  SSEResponseTypes,
  GeneratedFile,
  ResponseTimeAnalytics,
  ModelSelected,
  AssistantPositionRemainingType,
} from '../models/websockets.types';
import { SearchSource, Source } from 'features/chat/types/chat';

const SSEResponseParser = (parsedResponse: any): SSEResponse => {
  let responseType: SSEResponseTypes;
  try {
    responseType = parsedResponse.type as SSEResponseTypes;
  } catch (error) {
    console.error('Error parsing websocket response type:', error,parsedResponse);
    throw new Error('Invalid response type');
  }
  const finalResponse = {
    type: responseType,
    data: parsedResponse.data,
    message_sender_id: parsedResponse.messageSenderId,
    conversation_id: parsedResponse.conversation_id || parsedResponse?.conversationId,
    ...(parsedResponse.file_names && { file_names: parsedResponse.file_names }),
    ...(parsedResponse.assistant_message_id && { assistant_message_id: parsedResponse.assistant_message_id }),
    parent_ids: parsedResponse.parentIds,
  };

  // console.log('finalResponse in SSEResponseParser', finalResponse);

  switch (responseType) {
    case SSEResponseTypes.CODE_EXECUTION_STARTED:
    case SSEResponseTypes.CODE_EXECUTION_STEP:
    case SSEResponseTypes.LLM_ANSWER:
    case SSEResponseTypes.SEARCH_RESPONSE:
    case SSEResponseTypes.LLM_THINKING:
    case SSEResponseTypes.SERVER_ERROR:
    case SSEResponseTypes.CONVERSATION_TITLE:
    case SSEResponseTypes.END_OF_STREAM:
    case SSEResponseTypes.IMAGE_GENERATION_STARTED:
    case SSEResponseTypes.FILE_GENERATION_STARTED:
    case SSEResponseTypes.IMAGE_GENERATION_FAILED:
    case SSEResponseTypes.FILE_GENERATION_FAILED:
    case SSEResponseTypes.CONTEXT_WINDOW_EXCEEDED:
    case SSEResponseTypes.IMAGE_GENERATION_LIMIT_EXCEEDED:
      finalResponse.data = parsedResponse.data as string;
      break;
    case SSEResponseTypes.TOKEN_ANALYTICS:
      finalResponse.data = parsedResponse.data as TokenAnalytics;
      break;
    case SSEResponseTypes.FILE_GENERATION_ON_PROGRESS:
    case SSEResponseTypes.IMAGE_GENERATION_SUCCESS:
    case SSEResponseTypes.FILE_GENERATION_SUCCESS:
    case SSEResponseTypes.CODE_EXECUTION_ARTIFACT:
      finalResponse.data = parsedResponse.data as GeneratedFile;
      break;
    case SSEResponseTypes.RESPONSE_SOURCES:
      finalResponse.data = parsedResponse.data as Source[];
      break;
    case SSEResponseTypes.SEARCH_SOURCES:
      finalResponse.data = parsedResponse.data as SearchSource[];
      break;
    case SSEResponseTypes.ASSISTANT_REQUEST_PROCESSING_STARTED:
    case SSEResponseTypes.ASSISTANT_REQUEST_QUEUED:
      finalResponse.data = parsedResponse.data as AssistantPositionRemainingType;
      break;
    case SSEResponseTypes.RESPONSE_TIME_ANALYTICS:
      finalResponse.data = parsedResponse.data as ResponseTimeAnalytics;
      break;
    case SSEResponseTypes.MODEL_SELECTED:
      finalResponse.data = parsedResponse.data as ModelSelected;
      break;
    // case SSEResponseTypes.CONTEXT_WINDOW_EXCEEDED:
    // case SSEResponseTypes.IMAGE_GENERATION_LIMIT_EXCEEDED:
    //   finalResponse.data = parsedResponse.data as string;
    //   break;
    default:
      // console.error('Unhandled response type',parsedResponse.type);
      throw new Error('Unhandled response type',parsedResponse.type);
  }
  return finalResponse as SSEResponse;
 };
 
 export const WebsocketServices = {
  SSEResponseParser,
 };
 
 